// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-camera-preview-app-width {
    width: 403px;
}

.errormessage {
    margin-right: 10px;
    padding: 0;
    color: #ba2121;
    background: #fff;
    text-align: center;
  }`, "",{"version":3,"sources":["webpack://./src/asset/style/manualmode/live_camera_preview_app.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,kBAAkB;EACpB","sourcesContent":[".main-camera-preview-app-width {\n    width: 403px;\n}\n\n.errormessage {\n    margin-right: 10px;\n    padding: 0;\n    color: #ba2121;\n    background: #fff;\n    text-align: center;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
